import React, { useContext } from 'react';
import { Link } from 'gatsby';
import styled, { ThemeContext } from 'styled-components';
import { Button } from '../../Button';
import Hr from './Hr';

interface Props {
  action: string;
  link: string;
  text: string;
  internal: boolean;
  greyBg?: boolean;
  hasHr?: boolean;
  padding?: string;
}

export default ({ action, link, text, internal, greyBg, hasHr, padding }: Props) => {
  const themeContext = useContext(ThemeContext);

  return (
    <>
      {hasHr && <Hr />}
      <CTA greyBg={greyBg} padding={padding}>
        <P>{text}</P>
        {internal ? (
          <StyledLink to={`${link}/`} state={{ copy: action }}>
            <Button action={action} btnHeight="auto" bgColor={themeContext.colors.green} />
          </StyledLink>
        ) : (
          <A href={link} target="_blank" rel="noreferrer">
            <Button action={action} btnHeight="auto" bgColor={themeContext.colors.green} />
          </A>
        )}
      </CTA>
    </>
  );
};

const StyledLink = styled(Link)`
  margin-bottom: 0 !important;
  margin: 0 auto;

  * {
    margin-bottom: 0 !important;
  }
`;

const A = styled.a`
  margin-bottom: 0 !important;
  margin: 0 auto;

  * {
    margin-bottom: 0 !important;
  }
`;

interface CTAProps {
  greyBg?: boolean;
  padding?: string;
}

const CTA = styled.div<CTAProps>`
  display: grid;
  gap: 1.5rem;
  align-items: center;
  background: ${({ greyBg, theme }) => greyBg && theme.colors.grey200};
  padding: ${({ padding }) => padding};
  justify-items: center;
`;

const P = styled.p`
  text-align: center;
  font-size: 1.5rem;
  text-align: center;
  line-height: 1.4;
  padding: 0 1.5rem;
  max-width: 60ch;

  @media all and (max-width: 26.563em) {
    font-size: 1.25rem;
  }
`;
